import React, { useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@features/group-selection/ui/group-selection.scss';
import GroupSelectionSetsList from '@features/group-selection/ui/GroupSelectionSetsList';
import { GroupSelectionProvider } from '@context/groupSelectionContext';
import { GroupSelectionOutletContext } from '@features/group-selection/model/types';
import { useNavigatePreserveSearch } from '@hooks/useNavigatePreserveSearch';

const GroupSelection = ({
    entityName,
    sourceEntityName,
    groupUpdateTaskArgument,
    showDeleteBtn = true,
}: GroupSelectionOutletContext) => {
    const { t } = useTranslation();
    const navigate = useNavigatePreserveSearch();

    const onSetSave = useCallback((id: string) => {
        navigate(`./${id}`);
    }, []);

    return (
        <GroupSelectionProvider entityName={entityName} sourceEntityName={sourceEntityName}>
            <div className="group-selection">
                <section className="section">
                    <p className="description">{t('road-network.group-selection-description')}</p>
                    <Outlet
                        context={{
                            entityName,
                            sourceEntityName,
                            groupUpdateTaskArgument,
                            showDeleteBtn,
                        }}
                    />
                </section>
                <section className="section">
                    <GroupSelectionSetsList onSave={onSetSave} />
                </section>
            </div>
        </GroupSelectionProvider>
    );
};

export default GroupSelection;
